import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Button, message } from 'antd';
import { useTranslation } from 'react-i18next';
import { useAppConfig } from './AppConfigProvider';

const ManualSubmitModal = ({ visible, onClose, invoiceId }) => {
  const { t } = useTranslation();
  const { theme } = useAppConfig();
  const [form] = Form.useForm();
  const [uploading, setUploading] = useState(false);
  const einvoiceId = Form.useWatch('einvoiceId', form);

  useEffect(() => {
    if (visible) {
      form.setFieldsValue({ einvoiceId: invoiceId || '' });
    }
  }, [visible, invoiceId, form]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      setUploading(true);
      console.log('Manual submit payload:', {
        einvoiceId: values.einvoiceId,
      });
      message.success(t('manualSubmit.success'));
      setUploading(false);
      onClose();
    } catch (err) {
      // validation error, do nothing
    } finally {
      setUploading(false);
    }
  };

  return (
    <Modal
      open={visible}
      title={t('manualSubmit.title')}
      onCancel={onClose}
      footer={[
        <Button
          key="cancel"
          onClick={onClose}
          style={{
            borderColor: theme.primary,
            color: theme.primary,
          }}
        >
          {t('common.cancel')}
        </Button>,
        <Button
          key="upload"
          type="primary"
          loading={uploading}
          disabled={!einvoiceId}
          onClick={handleOk}
          style={{
            backgroundColor: einvoiceId ? theme.primary : '#E0E0E0',
            color:'#ffffff'
          }}
        >
          {t('manualSubmit.uploadButton')}
        </Button>,
      ]}
      destroyOnClose
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label={t('invoice.einvoiceId')}
          name="einvoiceId"
          rules={[{ required: true, message: t('manualSubmit.einvoiceIdRequired') }]}
        >
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ManualSubmitModal;

